import { RouteFactory } from "@app/routePaths";
import logoBTSG60 from "@assets/logo-btsg60.png";
import AdSettings from "@components/Advertisement/AdSettings";
import { KeywordButtonType } from "@components/Button/utils/types";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import { useBreadCrumbState } from "@components/Header/helpers";
import KeywordFilter from "@components/KeywordFilter";
import { KeywordType } from "@components/KeywordFilter/utils/types";
import { renderMetaDescription } from "@components/MetaTags/helpers";
import MetaTags from "@components/MetaTags/MetaTags";
import Highlights from "@pages/Keyword/customPages/BTSG60Page/components/Highlights/Highlights";
import MoreStories from "@pages/Keyword/customPages/BTSG60Page/components/MoreStories/MoreStories";
import Podcasts from "@pages/Keyword/customPages/BTSG60Page/components/Podcasts/Podcasts";
import { BTSG60PageContentProps } from "@pages/Keyword/customPages/BTSG60Page/utils/types";
import { Tag } from "@typings/Cue";
import { sectionNavigationItems } from "@util/constant";
import { useDetectAdBlock } from "adblock-detect-react";

/** The BT SG60 template page. */
const BTSG60PageContent = ({
  data: {
    title,
    entity,
    highlightArticles,
    pdfDownload,
    podcastArticles,
    moreStories,
  },
}: BTSG60PageContentProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();
  const { breadcrumbsRef, isShowBreadCrumb } = useBreadCrumbState();

  const {
    tag: { name, urlPath, id, type },
    urlPathHistory,
  } = entity;

  // @todo comment to changed this to FeedTag once myBT integration is done
  const legacyTag: Tag = {
    id,
    name: name,
    urlPath: urlPath,
    type: type,
    uri: "",
    urlPathHistory: urlPathHistory,
    aliases: [],
    fields: [],
    parent: null,
    sections: [],
  };

  return (
    <div data-testid="bt-sg-60-page-content" className="w-full">
      <AdSettings adNames={["lb1", "imu2"]} path={RouteFactory.btsg60} />

      <GAData
        chapter1={name}
        level2={"keywords"}
        title={"keywords"}
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={title}
        description={renderMetaDescription({ kind: "keyword", entity })}
        slug={RouteFactory.btsg60}
      />

      <Header
        displayBreadcrumb={isShowBreadCrumb}
        parentCategory={RouteFactory.btsg60.replace("/", "")}
        categoryDataMapping={sectionNavigationItems}
        enableTopStoriesLink={false}
        isShownMasthead
      />

      <Container rootClassName="py-8">
        <div
          ref={breadcrumbsRef}
          className="mb-7 flex items-center border-b border-gray-850 py-3"
        >
          <div>
            <img
              src={logoBTSG60}
              width={360}
              height={54}
              alt=""
              className="w-40"
            />
          </div>

          <KeywordFilter
            keywordButtonType={KeywordButtonType.version2}
            tag={legacyTag}
            rootClassName="inline-block w-full"
            tagClassName="border-none !font-playfair !text-6xl md:!text-8xl !p-0 text-gray-850 !uppercase !text-left !text-normal"
            disableTooltip
            keywordType={KeywordType.noTag}
            buttonClassName={"lg:ml-4"}
            isLinkenabled={false}
          />
        </div>

        <Highlights
          cardProps={highlightArticles}
          pdfDownload={pdfDownload}
          className="mb-8"
        />

        <Podcasts cardProps={podcastArticles} className="mb-8" />

        <MoreStories cardProps={moreStories} urlPath={urlPath} />
      </Container>
    </div>
  );
};

export default BTSG60PageContent;
